
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NavBar, MenuBar } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar
  }
})
export default class TaskMatchExpressionsCard extends Vue {
  @Prop({ required: true })readonly obj: any

  data () {
    return {
      isLoading: false,
      taskId: null,
      remainTime: '',
      disabled: true,
      taskData: null,
      score: null,
      scoreReason: null,
      description: '',
      words: [],
      content: '',
      wordsSequenceA: [],
      wordsSequenceB: [],
      matchIdxs: 0,
      isCorrectSequence: [],
      selectedItemA: null,
      selectedItemB: null,
      selectedItemAIdx: null,
      selectedItemBIdx: null
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.prepareTaskData()
    // this.mockTaskData()
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  selectItemSequenceA (item, idx) {
    if (this.matchIdxs <= idx) {
      this.selectedItemA = item
      this.selectedItemAIdx = idx
      if (this.selectedItemBIdx !== null) {
        // var idxB = this.wordsSequenceB.indexOf(this.selectedItemB)
        this.createMatch(idx, this.selectedItemBIdx)
      }
    }
  }

  selectItemSequenceB (item, idx) {
    if (this.matchIdxs <= idx) {
      this.selectedItemB = item
      this.selectedItemBIdx = idx
      if (this.selectedItemAIdx !== null) {
        // var idxA = this.wordsSequenceA.indexOf(this.selectedItemA)
        this.createMatch(this.selectedItemAIdx, idx)
      }
    }
  }

  createMatch (idxA, idxB) {
    var valueA = this.wordsSequenceA.splice(idxA, 1)[0]
    this.wordsSequenceA.unshift(valueA)
    var valueB = this.wordsSequenceB.splice(idxB, 1)[0]
    this.wordsSequenceB.unshift(valueB)
    this.matchIdxs = this.matchIdxs + 1
    this.selectedItemA = null
    this.selectedItemB = null
    this.selectedItemAIdx = null
    this.selectedItemBIdx = null
  }

  removeMatch (idx) {
    var valueA = this.wordsSequenceA.splice(idx, 1)
    this.wordsSequenceA.push(valueA[0])
    var valueB = this.wordsSequenceB.splice(idx, 1)
    this.wordsSequenceB.push(valueB[0])
    this.matchIdxs = this.matchIdxs - 1
  }

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  async prepareTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      if (resp.data) {
        this.taskData = JSON.parse(resp.data)
        if (!this.taskData.columnA) {
          this.taskData.columnA = []
        }
        if (!this.taskData.columnB) {
          this.taskData.columnB = []
        }
        this.correctAnswer = this.taskData.correctAnswer
        var acc
        if (this.taskData.columnA.length === this.taskData.columnB.length && this.taskData.columnB.length > 0) {
          this.wordsSequenceA = this.taskData.columnA
          this.wordsSequenceB = this.taskData.columnB
          for (var i = 0; i < this.wordsSequenceA.length; i++) {
            this.createMatch(i, i)
          }
        }
        if (this.wordsSequenceA.length < this.taskData.correctAnswer.length) {
          var correctAnswersBuffer = JSON.parse(JSON.stringify(this.taskData.correctAnswer))
          while (correctAnswersBuffer.length > 0) {
            var idx = Math.floor(Math.random() * correctAnswersBuffer.length)
            if (!this.wordsSequenceA.includes(correctAnswersBuffer[idx].columnA)) {
              this.wordsSequenceA.push(correctAnswersBuffer[idx].columnA)
            }
            correctAnswersBuffer.splice(idx, 1)
          }

          correctAnswersBuffer = JSON.parse(JSON.stringify(this.taskData.correctAnswer))
          for (i = 0; i < this.wordsSequenceB.length; i++) {
            idx = correctAnswersBuffer.findIndex(p => {
              return p.columnB === this.wordsSequenceB[i]
            })
            correctAnswersBuffer.splice(idx, 1)
          }
          while (correctAnswersBuffer.length > 0) {
            idx = Math.floor(Math.random() * correctAnswersBuffer.length)
            // if (!this.wordsSequenceB.includes(correctAnswersBuffer[idx].columnB)) {
            this.wordsSequenceB.push(correctAnswersBuffer[idx].columnB)
            // }
            correctAnswersBuffer.splice(idx, 1)
          }
        }
      }
      this.description = resp.description
      this.score = resp.score
      this.scoreReason = resp.scoreReason
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      if (this.score) {
        this.wordsSequenceA.map((e, idx) => {
          var correctIndex = this.correctAnswer.findIndex(p => {
            return p.columnA === e
          })
          var isCorrect = this.correctAnswer[correctIndex].columnB === this.wordsSequenceB[idx]
          this.isCorrectSequence.push(isCorrect)
          return 0
        })
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async mockTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      this.description = 'Match expressions from left column to right column'
      this.disabled = false
      this.wordsSequenceA = ['is', 'car', 'beautiful way more tall than', ' another column This', 'By', 'confirming', 'you', 'won`t', 'be', 'able to change it back', 'to', 'change', 'it', 'back.']
      this.wordsSequenceB = ['is', 'car', 'beautiful', 'This', 'By', 'confirming that is can be it', 'you', 'won`t', 'be', 'able', 'to', 'change', 'it', 'back.']
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var data = {
      columnA: this.wordsSequenceA.slice(0, this.matchIdxs),
      columnB: this.wordsSequenceB.slice(0, this.matchIdxs)
    }
    try {
      const resp = await FetchWrapper.post(
        `${process.env.VUE_APP_SERVERURL}/updateMatchExpressionsTaskData`,
        { data: data, id: Number(this.taskId), completed }
      )
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = `/home/task/${this.taskId}`
          }
        },
        canCancel: false
      })
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not save task data. ${e}`,
        canCancel: false
      })
    }
  }
}
